import { useEffect, useState } from 'react'

export const useMarkerHover = (ref: React.RefObject<HTMLDivElement>, isDragging: boolean): boolean => {
  const [isHover, setIsHover] = useState(false)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const handleMouseEnter = () => setIsHover(true)
    const handleMouseLeave = () => setIsHover(false)

    element.addEventListener('mouseenter', handleMouseEnter)
    element.addEventListener('mouseleave', handleMouseLeave)

    if (isDragging) {
      setIsHover(false)
    }

    return () => {
      element.removeEventListener('mouseenter', handleMouseEnter)
      element.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [ref, isDragging])

  return isHover
}
